import templateUrl from "emun.order/ticket-container-full.htm";
import controller from "emun.order/ticket-container.controller";

export default {
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
